import {CustomTextField} from "../CustomTextField";
import React, {FC} from "react";
import {ITextFieldProps as IProps} from "./types";
import cls from '../atoms.module.scss'

const TextField: FC<IProps> = ({
                                   item,
                                   index,
                                   savedFormData,
                                   handleChange,
                                   urlValidate,
                                   translationsData,
                               }) => {
    return (
        <div key={index} className={cls["signUp-position-relative"]}>
            <CustomTextField
                value={item.default_label}
                label={item.default_label}
                type={item.type}
                name={item.attribute_code}
                inpValue={(savedFormData as Record<string, string>)?.[item.attribute_code]}
                handleChange={(e) => handleChange(e, item.validation)}
                required={!!+item.is_required}
                custom={true}
            />
            <div className="alert alert-danger p-0 m-0">
                {
                    !urlValidate && item.validation === "url" &&
                    translationsData.InvalidUrl
                }
            </div>
        </div>
    )
}

export default TextField;